import { widgetSelector } from '../../shared/widget'

export const delay = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms))

export const waitForAnimationEnd = async (id: number, maxWait = 1500): Promise<void> => {
  const host = document.querySelector<HTMLElement>(widgetSelector(id))
  if (host) {
    await delay(50) // start with delay to give animations a chance to kick off
    const animations = host.shadowRoot?.getAnimations() || []
    await Promise.race([Promise.allSettled(animations.map(a => a.finished)), delay(maxWait)])
  }
}
